var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.87,
    height: 23.179,
    viewBox: "0 0 19.87 23.179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.591,6.157V0H1.242A1.169,1.169,0,0,0,0,1.087V22.093a1.169,1.169,0,0,0,1.242,1.087H18.628a1.169,1.169,0,0,0,1.242-1.087V7.244H12.832A1.175,1.175,0,0,1,11.591,6.157Zm3.956,9.569-4.989,4.333a.974.974,0,0,1-1.244,0L4.324,15.726c-.525-.456-.157-1.239.582-1.239H8.279V10.865a.781.781,0,0,1,.828-.724h1.656a.781.781,0,0,1,.828.724v3.622h3.373A.717.717,0,0,1,15.546,15.726ZM19.507,4.754,14.442.317A1.337,1.337,0,0,0,13.562,0h-.316V5.795H19.87V5.519A1.019,1.019,0,0,0,19.507,4.754Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDownload);
export default __webpack_public_path__ + "static/media/file_download.2b63236c.svg";
export { ForwardRef as ReactComponent };